// import ModalFakturPajak from "components/ModalFakturPajak";
import { setRequirement } from "features/common/layouts/cartSlice";
import React from "react";
import { useDispatch, useSelector } from "react-redux";

const ToSCompanyCheckBox = () => {
  const dispatch = useDispatch();
  // const [showFakturModal, setShowFakturModal] = useState(false);
  const { requirement, orderProcessName } = useSelector((state) => state.cart);

  const checkHandler = (e) => {
    const requirement = e.target;

    if (requirement.id === "tos") {
      dispatch(
        setRequirement({
          tos: requirement.checked && requirement.id === "tos" ? true : false,
        })
      );
    }

    if (requirement.id === "pph" && orderProcessName !== "domain") {
      dispatch(
        setRequirement({
          pph: requirement.checked && requirement.id === "pph" ? true : false,
        })
      );
    }
  };

  // const openFakturModal = () => {
  //   dispatch(setRequirement({ company: true }));
  //   setShowFakturModal(true);
  // };

  // const closeFakturModal = () => {
  //   if (!npwpUrl) {
  //     dispatch(setRequirement({ company: false }));
  //   }
  //   setShowFakturModal(false);
  // };

  return (
    <div className="py-3">
      {/* <div className="form-check mb-3">
        <input
          type="checkbox"
          className="form-check-input"
          name="internet"
          id="internet"
          value="internet"
          onChange={() => setIsInternetChecked(!isInternetChecked)}
          checked={isInternetChecked}
        />
        <label
          htmlFor="internet"
          className="ms-3 form-check-label"
          style={{ fontSize: "14px" }}
        >
          Saya bersedia untuk mendapatkan penawaran Internet Qwords
        </label>
      </div> */}
      {/* {orderProcessName === 'domain' || orderProcessName === 'domainBackorder' ? '' :
			<div className="form-check mb-3">
				<input
					type="checkbox"
					className="form-check-input"
					name="pph"
					id="pph"
					value="pph"
					onChange={checkHandler}
					checked={requirement.pph}
				/>
				<label htmlFor="pph" className="ms-3 form-check-label" style={{ fontSize: "14px" }}>
					Saya adalah Perusahaan dan Membutuhkan Pemotongan Pph 23 (Opsional)
				</label>
			</div>
			} */}

      {/* Butuh Faktur Pajak / NPWP
      <div className="mb-3 d-flex flex-column align-items-stretch gap-2 w-100 flex-sm-row align-items-sm-center flex-sm-nowrap gap-sm-3">
        <span className="fw-medium flex-shrink-0" style={{ fontSize: "14px", lineHeight: 1.3 }}>
          Butuh Faktur Pajak?
        </span>
        <button
          type="button"
          className="tos-npwp-attach-btn rounded-5 py-2 fw-bold w-100 w-sm-auto px-3 px-sm-4 align-self-stretch align-self-sm-auto text-center"
          style={{
            fontSize: "13px",
            lineHeight: 1.35,
            color: "#EE4D30",
            backgroundColor: "transparent",
            border: "1px solid #EE4D30",
            cursor: "pointer",
            maxWidth: "100%",
          }}
          onClick={openFakturModal}
        >
          Lampirkan NPWP Perusahaan
        </button>
      </div>

      <ModalFakturPajak show={showFakturModal} onHide={closeFakturModal} />
      */}

      <div className="form-check mb-3">
        <input
          type="checkbox"
          className="form-check-input"
          name="tos"
          id="tos"
          value="tos"
          onChange={checkHandler}
          checked={requirement.tos}
        />
        <label
          htmlFor="tos"
          className="ms-3 form-check-label"
          style={{ fontSize: "14px" }}
        >
          Saya telah membaca dan menyetujui{" "}
          <a
            className="text-decoration-none"
            href={`${process.env.REACT_APP_QWORDS_API}master-service-agreement/?tab-content=terms-of-service`}
            target="_blank"
            rel="noreferrer"
          >
            <span className="text-qw-primary fw-bold">Term of Service</span>
          </a>
        </label>
      </div>
    </div>
  );
};

export default ToSCompanyCheckBox;
